import { GridRowsProp } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { PaginationModel, PreviewGridRow } from 'src/components/kanri/pages/jichitai/SearchSupportRecipientsPage/BulkSupporterAssignmentDialog/types';
import { useUserData } from 'src/hooks/common/useUserData';
import { previewBulkSupporterAssignment } from 'src/utilities/restApi/kanri/assignment/previewBulkSupporterAssignment';

type PageInfo = {
  totalRowCount: number;
  hasNextPage: boolean;
  pageSize: number;
};

type HookParams = {
  open: boolean;
  paginationModel: PaginationModel;
};

export const useQuery = ({ open, paginationModel }: HookParams) => {
  const [controller, setController] = useState<AbortController>();
  const { userData } = useUserData();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [rows, setRows] = useState<GridRowsProp<PreviewGridRow>>([]);
  const [pageInfo, setPageInfo] = useState<PageInfo>({
    totalRowCount: 0,
    hasNextPage: false,
    pageSize: 0,
  });
  
  useEffect(() => {
    if (open){
      search();
    }
  }, [open, userData, paginationModel]);

  // 支援者一括割当プレビュー情報の検索
  const search = () => {
    if (userData) {
      controller?.abort();
      setIsLoading(true);

      const newController = new AbortController();
      setController(newController);

      previewBulkSupporterAssignment(
        {
          page: paginationModel.page,
          page_size: paginationModel.pageSize,
        },
        newController
      )
        .then((response) => {
          if (response.data) {
            const gridRows: GridRowsProp<PreviewGridRow> = response.data.search_results.rows.map((row) => ({
              id: row.prsid,
              name: row.name,
              allBelongingSoshikinames: row.all_belonging_soshikinames,
              assignedSoshikinames: row.assigned_soshikinames,
              newlyAssignedSoshikinames: row.newly_assigned_soshikinames,
            }));
            setRows(gridRows);
            setPageInfo({
              totalRowCount: response.data.search_results.page_info.total_row_count,
              hasNextPage: response.data.search_results.page_info.has_next_page,
              pageSize: paginationModel.pageSize,
            });
          }
        })
        .catch((error) => {
          if (error !== 'canceled') {
            setIsError(true);
          }
        })
        .finally(() => {
          if (!newController.signal.aborted) {
            setIsLoading(false);
          }
        });
    }
  };

  return { isLoading, rows, pageInfo, isError, search };
};
